import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SwalErrorService {
  public showError = new Subject<{
    title?: string;
    text?: string;
    showCancelButton?: boolean;
    type?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
  }>();
  public actionSubject = new Subject<any>();

  constructor(private translateService: TranslateService) {}

  public parseError(errors: {
    errors: any;
    message: string;
    new_price?: string;
    partial?: boolean;
  }): string {
    let str = '<ul class="text-center">';
    if (errors.errors) {
      for (const [key, value] of Object.entries(errors.errors)) {
        (value as any).forEach((el) => {
          if (errors.new_price && key === 'order') {
            str = `<h3 class="text-center">${el}</h3>` + str;
          } else {
            str += `<li class="mt-1">${el}</li>`;
          }
        });
      }
      // if (!errors.new_price || (errors.new_price && errors.partial)) {
      // } else {
      //   str = this.translateService.instant('ORDER_OVERDUE_ERROR');
      // }
    } else {
      str = errors.message;
      return str;
    }
    if (str === '<ul class="list-dotted>') {
      str = errors.message;
      return str;
    }
    str += '</ul>';
    if (errors.new_price && errors.partial) {
      str += `<h3 class="text-center mt-3 mb-0">${this.translateService.instant(
        'NEW_PRICE_IS'
      )}: ${errors.new_price} ${this.translateService.instant('BYN')}</h3>`;
    }
    return str;
  }
}
